import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';


import { updateConferenceCallEnded } from '../../../base/conference';
import { disconnect } from '../../../base/connection';
import { openDialog } from '../../../base/dialog';
import { Icon, IconHangup } from '../../../base/icons';
import { getYoutubeParticipant, kickParticipant } from '../../../base/participants';
import { getBrandingColorPalette } from '../../../base/styles';

import { AlertBox } from './AlertBox';
import { colorsHangup } from './Constants';

const styles = interfaceConfig => {
    return {
        hangUpEveryOne: {
            backgroundColor: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig).accent2 : colorsHangup(interfaceConfig).hangUpRed
        },
        hangUpAlone: {
            backgroundColor: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig).secondary : getBrandingColorPalette(interfaceConfig).primary
        },
        whiteColor: {
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig).accent1 : colorsHangup(interfaceConfig).white
        }
    };
};

type Props = {
    onLeaveEveryOne: ?Function
}


export const HangupContent = (props: Props) => {
    const { onLeaveEveryOne } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const partipicipantss = useSelector(state => state['features/base/participants']);
    const interfaceConfig = useSelector(state => state['features/base/config'].interfaceConfig);
    const rooms = useSelector(state => state['features/breakout-rooms']?.rooms || {});
    const isRemoteParticipants = partipicipantss.filter(it => it.local !== true && !it?.isFakeParticipant);
    const howManyModerators = partipicipantss.filter(it => it.role === 'moderator' && !it?.isFakeParticipant);

    const onJustHangUp = React.useCallback((isTrue = false) => {
        if (howManyModerators.length <= 1 && !isTrue && isRemoteParticipants.length > 0) {
            dispatch(openDialog(AlertBox, {
                alertText: 'dialog.HangupSingleLeaveReason',
                disableOverlay: false,
                submitDisabled: false,
                cancelDisabled: false,
                onSubmit: () => onJustHangUp(true),
                okKey: 'dialog.endAnyway'
            }));

            return;
        }

        dispatch(disconnect(false));
        dispatch(updateConferenceCallEnded(true));
    }, [ dispatch ]);


    const youtubeParticipant = useSelector(state => getYoutubeParticipant(state));
    const conference = useSelector(state => state['features/base/conference'].conference);

    const onRemoveEveryOneAndLeave = React.useCallback(() => {
        onLeaveEveryOne(true);
        for (let index = 0; index < isRemoteParticipants.length; index++) {
            hitFunc(index);
        }
        if (youtubeParticipant) {
            dispatch(kickParticipant(youtubeParticipant?.id));
        }

        const breakoutRooms = Object.values(rooms).filter(room => !room.isMainRoom);
        const breakoutRoomsManager = conference?.getBreakoutRooms();

        if (breakoutRoomsManager) {
            breakoutRooms.forEach(room => {
                if (room.jid) {
                    breakoutRoomsManager.removeBreakoutRoom(room.jid);
                }
            });
        }

        const hangupDelay = (isRemoteParticipants.length * 300) + 500;

        setTimeout(() => {
            onJustHangUp(true);
        }, hangupDelay);
    }, [ onLeaveEveryOne, isRemoteParticipants, youtubeParticipant, conference, onJustHangUp, rooms ]);


    // React.useEffect(() => {
    //     if (isRemoteParticipants.length === 0 && isLeaving) {
    //         dispatch(disconnect(false));
    //     }
    // }, [, isRemoteParticipants?.length ]);


    /**
         * Function for Loop.
         *
         * @param {any} index - Index.
         * @returns {any}
         */
    function hitFunc(index) {
        setTimeout(() => {
            const element = isRemoteParticipants[index];
            const tranlated = t('dialog.hangUpLeaveReason');

            dispatch(kickParticipant(element.id, tranlated));
        }, index * 300);
    }

    return (

        <div className = 'audio-preview-content'>
            <div className = 'hangup-main-view'>
                <div

                    className = 'hangup-alone-btn'
                    onClick = { () => onJustHangUp(false) }
                    style = { styles(interfaceConfig).hangUpAlone }>
                    <div
                        className = 'hangup-row-flex'>
                        <div className = 'hangup-padding-lr'>
                            <Icon src = { IconHangup } />

                        </div>
                        <div className = 'hangup-padding-lr' >
                            <p
                                className = 'hangup-white-color'
                                style = { styles(interfaceConfig).whiteColor }>
                                {t('toolbar.hangUpforMe')}
                            </p>

                        </div>
                    </div>
                </div>
                {
                    Array.isArray(isRemoteParticipants) && isRemoteParticipants.length > 0
                    && <div
                        className = 'hangup-everyone-btn'
                        onClick = { onRemoveEveryOneAndLeave }
                        style = { styles(interfaceConfig).hangUpEveryOne }>
                        <div
                            className = 'hangup-row-flex'>
                            <div className = 'hangup-padding-lr' >
                                <Icon src = { IconHangup } />

                            </div>
                            <div className = 'hangup-padding-lr' >
                                <p
                                    className = 'hangup-white-color'
                                    style = { styles(interfaceConfig).whiteColor }>
                                    {t('toolbar.hangUpforEveryOne')}
                                </p>

                            </div>
                        </div>
                    </div>
                }
            </div></div>

    );
};
